import React, { useState, useEffect } from "react";
import { getAuth, signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { getFirestore, collection, addDoc, getDocs, query, where, doc, updateDoc, orderBy, deleteDoc } from "firebase/firestore";


import { format, parseISO, isToday, isAfter, isBefore, addDays } from 'date-fns';
import { Badge, List, Avatar, Divider, Typography, Alert } from 'antd';
import { BellOutlined, CalendarOutlined, ExclamationCircleOutlined } from '@ant-design/icons';


import { jsPDF } from "jspdf";
import * as XLSX from 'xlsx';
import './body.css';


import { Eye, Download } from "lucide-react";

const db = getFirestore();

const { Title, Text } = Typography;

const Body = () => {

  const [selectedOption, setSelectedOption] = useState("addPatient"); // Default to "home"
  const [userDetails, setUserDetails] = useState(null); // Define userDetails state
  const auth = getAuth(); // Initialize Firebase Auth
  const navigate = useNavigate(); // Initialize navigate
  const db = getFirestore(); // Initialize Firestore



//fetch all the eye exam report
const [eyeExamRecords, setEyeExamRecords] = useState([]);
const [selectedRecord, setSelectedRecord] = useState(null);


//search function in view eye report
const [filterOption, setFilterOption] = useState('all');



// Add Patient 
  const [formData, setFormData] = useState({
    name: '',
    dateOfBirth: '',
    sex: '',
    telephoneNo: '',
    address: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, 'patients'), formData);
      alert('Patient added successfully!');
      // Reset form
      setFormData({
        name: '',
        dateOfBirth: '',
        sex: '',
        telephoneNo: '',
        address: ''
      });
    } catch (error) {
      console.error('Error adding patient: ', error);
      alert('Error adding patient');
    }
  };



//Fetch all patients
const [patients, setPatients] = useState([]);
const [loading, setLoading] = useState(true);

useEffect(() => {
  const fetchPatients = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, 'patients'));
      const patientsData = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setPatients(patientsData);
    } catch (error) {
      console.error("Error fetching patients: ", error);
    } finally {
      setLoading(false);
    }
  };

  fetchPatients();
}, []);

// State variables
const [searchTerm, setSearchTerm] = useState("");
const [editingPatient, setEditingPatient] = useState(null);
const [filteredPatients, setFilteredPatients] = useState([]);

// Filter patients based on search term
useEffect(() => {
  const filtered = patients.filter(patient =>
    patient.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );
  setFilteredPatients(filtered);
}, [searchTerm, patients]);

// Handle patient update
const handleUpdatePatient = async (e) => {
  e.preventDefault();
  try {
    const patientRef = doc(db, "patients", editingPatient.id);
    await updateDoc(patientRef, editingPatient);
    setPatients(patients.map(p => p.id === editingPatient.id ? editingPatient : p));
    setEditingPatient(null);
    alert("Patient updated successfully!");
  } catch (error) {
    console.error("Error updating patient: ", error);
    alert("Error updating patient. Please try again.");
  }
};





// Add this function to delete a patient
const handleDeletePatient = async (patientId) => {
  const confirmDelete = window.confirm("Are you sure you want to delete this patient record?");
  if (!confirmDelete) return;

  try {
    await deleteDoc(doc(db, "patients", patientId));
    setPatients(patients.filter(patient => patient.id !== patientId));
    alert("Patient deleted successfully!");
  } catch (error) {
    console.error("Error deleting patient: ", error);
    alert("Failed to delete patient.");
  }
};





// Export to Excel
const handleDownloadPatients = () => {
  if (filteredPatients.length === 0) {
    alert("No patient data to download.");
    return;
  }
  
  const worksheet = XLSX.utils.json_to_sheet(filteredPatients);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Patients");
  XLSX.writeFile(workbook, "patient_records.xlsx");
};





// to create invoice
  const [to, setTo] = useState(""); // To field
  const [date, setDate] = useState(""); // Date field
  const [description, setDescription] = useState(""); // Description field
  const [amount, setAmount] = useState(""); // Amount field
  const [totalAmount, setTotalAmount] = useState(0); // Total amount
  const [invoiceNumber, setInvoiceNumber] = useState(""); // Start Invoice No 
  const [deductAmount, setDeductAmount] = useState(""); // New state for deduct amount


//01 create invoice
const handleCreateInvoice = async () => {
  if (!to || !date || !description || !amount || !invoiceNumber || deductAmount === undefined) {
    window.alert("Please fill in all required fields before proceeding!");
    return;
  }

  const totalAmount = parseFloat(amount) - parseFloat(deductAmount);

  const invoiceData = {
    to: String(to).trim(),
    date: String(date).trim(),
    description: String(description).trim(),
    amount: parseFloat(amount) || 0,
    deductAmount: parseFloat(deductAmount) || 0,
    totalAmount: totalAmount || 0,
    invoiceNo: invoiceNumber,
    createdAt: new Date(),
  };

  try {
    await addDoc(collection(db, "invoices"), invoiceData);

    // Create PDF with A5 landscape size
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: [210, 148], // A5 landscape
    });

    // --- Professional Font Setup ---
    doc.setFont("helvetica", "normal");
    
    // --- Header ---
    doc.setFillColor(16, 72, 123); // page header color
    doc.rect(0, 0, doc.internal.pageSize.getWidth(), 25, "F");
    
    // Logo and Clinic Info
    doc.addImage("/new-logo-aklo.png", "PNG", 10, 5, 20, 15);
    doc.setFontSize(14);
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.text("Aklo Vision Center", 35, 12);
    doc.setFontSize(9);
    doc.text("139 B, Hospital Road, Kalubowila, Dehiwala", 35, 17);
    doc.text("Tel: 0112 764677", 35, 22);


    
    // --- INVOICE Title ---
    doc.setFontSize(16);
    doc.setTextColor(0, 0, 0);
    doc.text("INVOICE", doc.internal.pageSize.getWidth() / 2, 35, { align: "center" });

    // --- Invoice Details ---
    doc.setFontSize(10);
    const detailsY = 45;
    
    // Patient Info
    doc.text(`Patient: ${invoiceData.to}`, 10, detailsY);
    
    // Invoice Number and Date (right aligned)
    doc.text(`Invoice No: ${invoiceData.invoiceNo}`, doc.internal.pageSize.getWidth() - 10, detailsY, { align: "right" });
    doc.text(`Date: ${invoiceData.date}`, doc.internal.pageSize.getWidth() - 10, detailsY + 7, { align: "right" });

    // --- Table Section ---
    let currentY = 60;
    
    // Table Header
    doc.setDrawColor(0);
    doc.setFillColor(230, 230, 230);  // Table Header color code
    doc.rect(10, currentY, doc.internal.pageSize.getWidth() - 20, 8, "F");
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text("DESCRIPTION", 12, currentY + 6);
    doc.text("AMOUNT (Rs.)", doc.internal.pageSize.getWidth() - 12, currentY + 6, { align: "right" });
    
    currentY += 12;

    // Description with automatic line breaks
    const descriptionLines = doc.splitTextToSize(invoiceData.description, doc.internal.pageSize.getWidth() - 50);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    
    // Print each line of description
    descriptionLines.forEach(line => {
      doc.text(line, 12, currentY);
      currentY += 5; // Line spacing
    });

    // Amount aligned to the right
    doc.text(`Rs. ${invoiceData.amount.toFixed(2)}`, doc.internal.pageSize.getWidth() - 12, 72, { align: "right" });

    // Deduction and Total
    currentY = Math.max(currentY, 85); // Ensure minimum space
    
    // Deduction
    doc.text("Advance Payment", 12, currentY);
    doc.text(`Rs. ${invoiceData.deductAmount.toFixed(2)}`, doc.internal.pageSize.getWidth() - 12, currentY, { align: "right" });
    
    // Total
    currentY += 10;
    doc.setFont("helvetica", "bold");
    doc.text("BALANCE PAYABLE", 12, currentY);
    doc.text(`Rs. ${invoiceData.totalAmount.toFixed(2)}`, doc.internal.pageSize.getWidth() - 12, currentY, { align: "right" });

    // Horizontal line above footer
    doc.line(10, currentY + 5, doc.internal.pageSize.getWidth() - 10, currentY + 5);

    // --- Footer ---
    doc.setFillColor(119, 175, 64); // Orange
    doc.rect(0, doc.internal.pageSize.getHeight() - 10, doc.internal.pageSize.getWidth(), 10, "F");
    doc.setFontSize(8);
    doc.setTextColor(0, 0, 0);
    doc.text("Vision for Knowledge & Survival", 
             doc.internal.pageSize.getWidth() / 2, doc.internal.pageSize.getHeight() - 5, 
             { align: "center" });

    // Save PDF
    doc.save(`Invoice_${invoiceNumber}.pdf`);

    // Reset form
    setInvoiceNumber("");
    setTo("");
    setDate("");
    setDescription("");
    setAmount("");
    setDeductAmount(0);
    
  } catch (error) {
    console.error("Error creating invoice: ", error);
    window.alert("Failed to create invoice. Please try again.");
  }
};







  
// View invoices
const [invoices, setInvoices] = useState([]); // State to store invoices

// download excel sheet 
const handleDownload = () => {
  if (invoices.length === 0) {
    alert("No invoices to download.");
    return;
  }

  // Convert invoice data to worksheet
  const worksheet = XLSX.utils.json_to_sheet(invoices);
  
  // Create a new workbook and append the worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Invoices");

  // Trigger download
  XLSX.writeFile(workbook, "invoices.xlsx");
};

// Add these state variables at the top with your other states
const [filteredInvoices, setFilteredInvoices] = useState([]);

// Update the useEffect to include filtering
useEffect(() => {
  const fetchInvoices = async () => {
    try {
      const invoicesCollection = collection(db, "invoices");
      const invoiceSnapshot = await getDocs(invoicesCollection);
      const invoiceList = invoiceSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));
      
      setInvoices(invoiceList);
      setFilteredInvoices(invoiceList); // Initialize filtered invoices
    } catch (error) {
      console.error("Error fetching invoices: ", error);
    }
  };

  fetchInvoices();
}, []);

// Add this useEffect to filter invoices when searchTerm changes
useEffect(() => {
  if (searchTerm.trim() === "") {
    setFilteredInvoices(invoices);
  } else {
    const filtered = invoices.filter(invoice => 
      invoice.to.toLowerCase().includes(searchTerm.toLowerCase()) ||
      invoice.invoiceNo.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredInvoices(filtered);
  }
}, [searchTerm, invoices]);




// Add this function to delete an invoice
const handleDeleteInvoice = async (invoiceId) => {
  const confirmDelete = window.confirm("Are you sure you want to delete this invoice?");
  if (!confirmDelete) return;

  try {
    await deleteDoc(doc(db, "invoices", invoiceId));
    
    // Update both invoices and filteredInvoices state
    setInvoices(invoices.filter(invoice => invoice.id !== invoiceId));
    setFilteredInvoices(filteredInvoices.filter(invoice => invoice.id !== invoiceId));
    
    alert("Invoice deleted successfully!");
  } catch (error) {
    console.error("Error deleting invoice: ", error);
    alert("Failed to delete invoice.");
  }
};



















// Add this function to generate PDF for individual invoices
const generatePDF = (invoiceData) => {
  // Create PDF with A5 landscape size
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: [210, 148], // A5 landscape
  });

  // --- Professional Font Setup ---
  doc.setFont("helvetica", "normal");
  
  // --- Header ---
  doc.setFillColor(16, 72, 123); // page header color
  doc.rect(0, 0, doc.internal.pageSize.getWidth(), 25, "F");
  
  // Logo and Clinic Info
  doc.addImage("/new-logo-aklo.png", "PNG", 10, 5, 20, 15);
  doc.setFontSize(14);
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.text("Aklo Vision Center", 35, 12);
  doc.setFontSize(9);
  doc.text("139 B, Hospital Road, Kalubowila, Dehiwala", 35, 17);
  doc.text("Tel: 0112 764677", 35, 22);

  // --- INVOICE Title ---
  doc.setFontSize(16);
  doc.setTextColor(0, 0, 0);
  doc.text("INVOICE", doc.internal.pageSize.getWidth() / 2, 35, { align: "center" });

  // --- Invoice Details ---
  doc.setFontSize(10);
  const detailsY = 45;
  
  // Patient Info
  doc.text(`Patient: ${invoiceData.to}`, 10, detailsY);
  
  // Invoice Number and Date (right aligned)
  doc.text(`Invoice No: ${invoiceData.invoiceNo}`, doc.internal.pageSize.getWidth() - 10, detailsY, { align: "right" });
  doc.text(`Date: ${invoiceData.date}`, doc.internal.pageSize.getWidth() - 10, detailsY + 7, { align: "right" });

  // --- Table Section ---
  let currentY = 60;
  
  // Table Header
  doc.setDrawColor(0);
  doc.setFillColor(230, 230, 230);  // Table Header color code
  doc.rect(10, currentY, doc.internal.pageSize.getWidth() - 20, 8, "F");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.text("DESCRIPTION", 12, currentY + 6);
  doc.text("AMOUNT (Rs.)", doc.internal.pageSize.getWidth() - 12, currentY + 6, { align: "right" });
  
  currentY += 12;

  // Description with automatic line breaks
  const descriptionLines = doc.splitTextToSize(invoiceData.description, doc.internal.pageSize.getWidth() - 50);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  
  // Print each line of description
  descriptionLines.forEach(line => {
    doc.text(line, 12, currentY);
    currentY += 5; // Line spacing
  });

  // Amount aligned to the right
  doc.text(`Rs. ${invoiceData.amount.toFixed(2)}`, doc.internal.pageSize.getWidth() - 12, 72, { align: "right" });

  // Deduction and Total
  currentY = Math.max(currentY, 85); // Ensure minimum space
  
  // Deduction
  doc.text("Advance Payment", 12, currentY);
  doc.text(`Rs. ${invoiceData.deductAmount.toFixed(2)}`, doc.internal.pageSize.getWidth() - 12, currentY, { align: "right" });
  
  // Total
  currentY += 10;
  doc.setFont("helvetica", "bold");
  doc.text("BALANCE PAYABLE", 12, currentY);
  doc.text(`Rs. ${invoiceData.totalAmount.toFixed(2)}`, doc.internal.pageSize.getWidth() - 12, currentY, { align: "right" });

  // Horizontal line above footer
  doc.line(10, currentY + 5, doc.internal.pageSize.getWidth() - 10, currentY + 5);

  // --- Footer ---
  doc.setFillColor(119, 175, 64); // Orange
  doc.rect(0, doc.internal.pageSize.getHeight() - 10, doc.internal.pageSize.getWidth(), 10, "F");
  doc.setFontSize(8);
  doc.setTextColor(0, 0, 0);
  doc.text("Vision for Knowledge & Survival", 
           doc.internal.pageSize.getWidth() / 2, doc.internal.pageSize.getHeight() - 5, 
           { align: "center" });

  // Save PDF
  doc.save(`Invoice_${invoiceData.invoiceNo}.pdf`);
};










  // Handle Logout
  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/"); // Redirect to login page after logout
    } catch (error) {
      console.error("Error during logout: ", error);
    }
  };
  

  // Example: Fetch user details (you might want to update this based on your logic)
  useEffect(() => {
    // Logic to fetch user details from Firestore or Firebase Auth
    const fetchUserDetails = async () => {
      const user = auth.currentUser;
      if (user) {
        // If the user is logged in, set userDetails (you can fetch more details from Firestore if needed)
        setUserDetails({
          name: user.displayName,
          email: user.email,
        });
      }
    };

    fetchUserDetails();
  }, [auth]);






//create consultation invoive

// Create consultation invoice
const handleCreateConsultationInvoice = async () => {
  if (!to || !date || !description || !amount || !invoiceNumber) {
    window.alert("Please fill in all required fields before proceeding!");
    return;
  }

  const totalAmount = parseFloat(amount) - parseFloat(deductAmount);

  const consultationData = {
    patientName: String(to).trim(),
    date: String(date).trim(),
    description: String(description).trim(),
    amount: parseFloat(amount) || 0,
    totalAmount: totalAmount || 0,
    invoiceNo: invoiceNumber,
    type: "consultation", // Add type to distinguish
    createdAt: new Date(),
  };

  try {
    // Save to "consultation" collection in Firestore
    await addDoc(collection(db, "consultation"), consultationData);

    // Create PDF with A5 landscape size
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: [210, 148], // A5 landscape
    });

    // --- Professional Font Setup ---
    doc.setFont("helvetica", "normal");
    
    // --- Header ---
    doc.setFillColor(16, 72, 123); // PAGE HEADER COLOR
    doc.rect(0, 0, doc.internal.pageSize.getWidth(), 25, "F");
    
    // Logo and Clinic Info
    doc.addImage("/new-logo-aklo.png", "PNG", 10, 5, 20, 15);
    doc.setFontSize(14);
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.text("Aklo Vision Center", 35, 12);
    doc.setFontSize(9);
    doc.text("139 B, Hospital Road, Kalubowila, Dehiwala", 35, 17);
    doc.text("Tel: 0112 764677", 35, 22);

    // --- CONSULTATION INVOICE Title ---
    doc.setFontSize(16);
    doc.setTextColor(0, 0, 0);
    doc.text("CONSULTATION INVOICE", doc.internal.pageSize.getWidth() / 2, 35, { align: "center" });

    // --- Invoice Details ---
    doc.setFontSize(10);
    const detailsY = 45;
    
    // Patient Info
    doc.text(`Patient: ${consultationData.patientName}`, 10, detailsY);
    
    // Invoice Number and Date (right aligned)
    doc.text(`Invoice No: ${consultationData.invoiceNo}`, doc.internal.pageSize.getWidth() - 10, detailsY, { align: "right" });
    doc.text(`Date: ${consultationData.date}`, doc.internal.pageSize.getWidth() - 10, detailsY + 7, { align: "right" });

    // --- Table Section ---
    let currentY = 60;
    
    // Table Header
    doc.setDrawColor(0);
    doc.setFillColor(230, 230, 230);
    doc.rect(10, currentY, doc.internal.pageSize.getWidth() - 20, 8, "F");
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text("DESCRIPTION", 12, currentY + 6);
    doc.text("AMOUNT (Rs.)", doc.internal.pageSize.getWidth() - 12, currentY + 6, { align: "right" });
    
    currentY += 12;

    // Description with automatic line breaks
    const descriptionLines = doc.splitTextToSize(consultationData.description, doc.internal.pageSize.getWidth() - 50);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    
    // Print each line of description
    descriptionLines.forEach(line => {
      doc.text(line, 12, currentY);
      currentY += 5; // Line spacing
    });

    // Amount aligned to the right
    doc.text(`Rs. ${consultationData.amount.toFixed(2)}`, doc.internal.pageSize.getWidth() - 12, 72, { align: "right" });

    // Deduction and Total
    currentY = Math.max(currentY, 85); // Ensure minimum space
    
  
    
    // Total
    currentY += 10;
    doc.setFont("helvetica", "bold");
    doc.text("BALANCE PAYABLE", 12, currentY);
    doc.text(`Rs. ${consultationData.totalAmount.toFixed(2)}`, doc.internal.pageSize.getWidth() - 12, currentY, { align: "right" });

    // Horizontal line above footer
    doc.line(10, currentY + 5, doc.internal.pageSize.getWidth() - 10, currentY + 5);

    // --- Footer ---
    doc.setFillColor(119, 175, 64); //footer color
    doc.rect(0, doc.internal.pageSize.getHeight() - 10, doc.internal.pageSize.getWidth(), 10, "F");
    doc.setFontSize(8);
    doc.setTextColor(0, 0, 0);
    doc.text("Vision for Knowledge & Survival", 
             doc.internal.pageSize.getWidth() / 2, doc.internal.pageSize.getHeight() - 5, 
             { align: "center" });

    // Save PDF
    doc.save(`Consultation_Invoice_${invoiceNumber}.pdf`);

    // Reset form
    setInvoiceNumber("");
    setTo("");
    setDate("");
    setDescription("");
    setAmount("");
    setDeductAmount(0);
    
  } catch (error) {
    console.error("Error creating consultation invoice: ", error);
    window.alert("Failed to create consultation invoice. Please try again.");
  }
};




  







//fetch all previous consultation invoices


const [consultationInvoices, setConsultationInvoices] = useState([]);
const [selectedInvoice, setSelectedInvoice] = useState(null);

// Fetch consultation invoices from Firestore
useEffect(() => {
  const fetchConsultationInvoices = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "consultation"));
      const invoices = [];
      querySnapshot.forEach((doc) => {
        invoices.push({ id: doc.id, ...doc.data() });
      });
      setConsultationInvoices(invoices);
    } catch (error) {
      console.error("Error fetching consultation invoices: ", error);
    }
  };

  fetchConsultationInvoices();
}, []);

const handleViewInvoice = (invoice) => {
  setSelectedInvoice(invoice);
};










  // Patient Information
  const [patientName, setPatientName] = useState('');
  const [examDate, setExamDate] = useState('');
  const [patientId, setPatientId] = useState('');
  const [dob, setDob] = useState('');
  const [age, setAge] = useState('');
  const [gender, setGender] = useState('');
  const [contactNo, setContactNo] = useState('');
  const [email, setEmail] = useState('');
  const [fundi, setFundi] = useState('');

  // History Taking
  const [chiefComplaint, setChiefComplaint] = useState('');
  const [hpc, setHpc] = useState('');
  const [pastOcularHistory, setPastOcularHistory] = useState('');
  const [medicalHistory, setMedicalHistory] = useState('');
  const [familyOcularHistory, setFamilyOcularHistory] = useState('');
  const [socialHistory, setSocialHistory] = useState('');




const [lids, setLids] = useState('');
const [conjunctiva, setConjunctiva] = useState('');
const [cornea, setCornea] = useState('');
const [sclera, setSclera] = useState('');
const [ac, setAc] = useState('');
const [lens, setLens] = useState('');
const [vitreous, setVitreous] = useState('');


// External Examination (Left and Right Eye - separate states)
const [lidsLeft, setLidsLeft] = useState('');
const [lidsRight, setLidsRight] = useState('');

const [conjunctivaLeft, setConjunctivaLeft] = useState('');
const [conjunctivaRight, setConjunctivaRight] = useState('');

const [corneaLeft, setCorneaLeft] = useState('');
const [corneaRight, setCorneaRight] = useState('');

const [scleraLeft, setScleraLeft] = useState('');
const [scleraRight, setScleraRight] = useState('');

const [acLeft, setAcLeft] = useState('');
const [acRight, setAcRight] = useState('');

const [lensLeft, setLensLeft] = useState('');
const [lensRight, setLensRight] = useState('');

const [vitreousLeft, setVitreousLeft] = useState('');
const [vitreousRight, setVitreousRight] = useState('');






// const [externalExam, setExternalExam] = useState({
//   lids: { left: '', right: '' },
//   conjunctiva: { left: '', right: '' },
//   cornea: { left: '', right: '' },
//   sclera: { left: '', right: '' },
//   ac: { left: '', right: '' },
//   lens: { left: '', right: '' },
//   vitreous: { left: '', right: '' }
// });

// // Handler for all external exam fields
// const handleExternalExamChange = (field, eye, value) => {
//   setExternalExam(prev => ({
//     ...prev,
//     [field]: { ...prev[field], [eye]: value }
//   }));
// };








  // Family History
  const [familyHistory, setFamilyHistory] = useState({
    poag: false,
    amd: false,
    dm: false,
    other: '',
  });

  // Visual Acuity
  const [visualAcuity, setVisualAcuity] = useState({
    od_cg: '',
    od_sg: '',
    od_ph: '',
    os_cg: '',
    os_sg: '',
    os_ph: '',
    ct: '',
    npc: '',
    om: '',
  });


  //HbRx

  const [hbrx, setHbrx] = useState({
    hb_od_sph: '',
    hb_od_cyl: '',
    hb_od_axis: '',
    hb_od_vision: '',
    rx_os_sph: '',
    rx_os_cyl: '',
    rx_os_axis: '',
    rx_os_vision: '',
  });




  // Refraction
  const [refraction, setRefraction] = useState({
    od_sph: '',
    od_cyl: '',
    od_axis: '',
    od_vision: '',
    os_sph: '',
    os_cyl: '',
    os_axis: '',
    os_vision: '',
  });

  // Follow Up
  const [needsFollowUp, setNeedsFollowUp] = useState(false);
  const [followUpDate, setFollowUpDate] = useState('');
  const [remarks, setRemarks] = useState('');

  const handleFamilyHistoryChange = (e) => {
    const { name, checked, value } = e.target;
    if (name === 'other') {
      setFamilyHistory({ ...familyHistory, other: value });
    } else {
      setFamilyHistory({ ...familyHistory, [name]: checked });
    }
  };

  const handleVisualAcuityChange = (e) => {
    const { name, value } = e.target;
    setVisualAcuity({ ...visualAcuity, [name]: value });
  };

  const handleHbrxChange = (e) => {
    const { name, value } = e.target;
    setHbrx({ ...hbrx, [name]: value });
  };


  const handleRefractionChange = (e) => {
    const { name, value } = e.target;
    setRefraction({ ...refraction, [name]: value });
  };

  const handleEyeExamSubmit = async (e) => {
    e.preventDefault();

    if (!patientName || !examDate) {
      alert('Please fill in patient name and date');
      return;
    }

    const eyeExamData = {
      patientInfo: {
        name: patientName,
        date: examDate,
        id: patientId,
        dob: dob,
        age,
        gender,
        contactNo,
        email,
        fundi,
      },
      history: {
        chiefComplaint,
        hpc,
        pastOcularHistory,
        medicalHistory,
        familyOcularHistory,
        socialHistory,
      },

      externalExam: {
        lids,
        conjunctiva,
        cornea,
        sclera,
        ac,
        lens,
        vitreous,
      },


      familyHistory,
      visualAcuity,
      hbrx,
      refraction,
      followUp: {
        needed: needsFollowUp,
        date: followUpDate,
        remarks,
      },
      createdAt: new Date(),
    };

    try {
      // Save to Firestore
      await addDoc(collection(db, 'eyeExams'), eyeExamData);
      
      // Generate PDF
      generateEyeExamPDF(eyeExamData);
      
      alert('Eye exam report saved successfully!');
    } catch (error) {
      console.error('Error saving eye exam: ', error);
      alert('Failed to save eye exam');
    }
  };

  const generateEyeExamPDF = (data) => {
    const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4',
    });

    // Set default font styles
    doc.setFont('helvetica');
    doc.setTextColor(0, 0, 0); // Black text

    // Constants for layout
    const leftMargin = 15;
    const rightMargin = 15;
    const pageWidth = 210 - leftMargin - rightMargin;
    const column1 = leftMargin;
    const column2 = 100;
    const columnWidth = 80;

    // Header Section
    doc.addImage('/new-logo-aklo.png', 'PNG', leftMargin, 10, 20, 20); // Larger logo
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.text('AKLO VISION CENTER', leftMargin + 25, 18);
    doc.setFontSize(10);
    doc.text('No. 139/B, Hospital Rd, Kalubowila', leftMargin + 25, 23);
    doc.text('Tel: 011 276 4677', leftMargin + 25, 28);
    doc.text(`Date: ${data.patientInfo.date}`, 180, 18, { align: 'right' });
    doc.line(leftMargin, 32, 210 - rightMargin, 32); // Horizontal line

    // Report Title
    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    doc.text('EYE EXAMINATION REPORT', 105, 42, { align: 'center' });
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');

    // Patient Information (Two Columns)
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text('PATIENT INFORMATION', leftMargin, 50);
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    
    // Column 1
    doc.text(`Name: ${data.patientInfo.name}`, column1, 56);
    doc.text(`Patient ID: ${data.patientInfo.id || '-'}`, column1, 62);
    doc.text(`Age: ${data.patientInfo.age || '-'}`, column1, 68);
    doc.text(`Gender: ${data.patientInfo.gender || '-'}`, column1, 74);
    
    // Column 2
    doc.text(`Contact: ${data.patientInfo.contactNo || '-'}`, column2, 56);
    doc.text(`Email: ${data.patientInfo.email || '-'}`, column2, 62);
    doc.text(`DOB: ${data.patientInfo.dob || '-'}`, column2, 68);
    doc.line(leftMargin, 78, 210 - rightMargin, 78); // Divider line

    // Helper functions
    const addSection = (title, content, y, maxWidth = pageWidth) => {
        doc.setFontSize(11);
        doc.setFont('helvetica', 'bold');
        doc.text(title.toUpperCase(), leftMargin, y);
        doc.setFontSize(10);
        doc.setFont('helvetica', 'normal');
        
        const lines = doc.splitTextToSize(content || '-', maxWidth);
        doc.text(lines, leftMargin + 5, y + 6);
        return y + (lines.length * 5) + 10;
    };

    const addExamTable = (title, data, y, columns) => {
        doc.setFontSize(11);
        doc.setFont('helvetica', 'bold');
        doc.text(title.toUpperCase(), leftMargin, y);
        y += 6;
        
        // Table header
        doc.setFontSize(10);
        doc.setFont('helvetica', 'bold');
        columns.forEach((col, i) => {
            doc.text(col.label, leftMargin + (i * 40), y);
        });
        y += 6;
        
        // Table data
        doc.setFont('helvetica', 'normal');
        data.forEach(row => {
            columns.forEach((col, i) => {
                doc.text(row[col.key] || '-', leftMargin + (i * 40), y);
            });
            y += 6;
        });
        
        return y + 6;
    };

    let yPos = 82;

    // History Sections
    yPos = addSection('Chief Complaint', data.history.chiefComplaint, yPos);
    yPos = addSection('History of Present Complaint', data.history.hpc, yPos);
    yPos = addSection('Past Ocular History', data.history.pastOcularHistory, yPos);
    yPos = addSection('Medical History', data.history.medicalHistory, yPos);
    yPos = addSection('Family Ocular History', data.history.familyOcularHistory, yPos);
    yPos = addSection('Social History', data.history.socialHistory, yPos);

    // Check for page break
    if (yPos > 250) {
        doc.addPage();
        yPos = 20;
    }

 // External Examination Table
yPos = addExamTable('External Examination', [
  { structure: 'Lids', left: lidsLeft || '-', right: lidsRight || '-' },
  { structure: 'Conjunctiva', left: conjunctivaLeft || '-', right: conjunctivaRight || '-' },
  { structure: 'Cornea', left: corneaLeft || '-', right: corneaRight || '-' },
  { structure: 'Sclera', left: scleraLeft || '-', right: scleraRight || '-' },
  { structure: 'A/C', left: acLeft || '-', right: acRight || '-' },
  { structure: 'Lens', left: lensLeft || '-', right: lensRight || '-' },
  { structure: 'Vitreous', left: vitreousLeft || '-', right: vitreousRight || '-' }
], yPos, [
  { label: 'Structure', key: 'structure' },
  { label: 'Left Eye', key: 'left' },
  { label: 'Right Eye', key: 'right' }
]);





    // Family History
    yPos = addSection('Family History', 
        `POAG: ${data.familyHistory.poag ? 'Yes' : 'No'}, ` +
        `AMD: ${data.familyHistory.amd ? 'Yes' : 'No'}, ` +
        `DM: ${data.familyHistory.dm ? 'Yes' : 'No'}` +
        (data.familyHistory.other ? `, Other: ${data.familyHistory.other}` : ''), 
        yPos);

    // Visual Acuity
    yPos = addExamTable('Visual Acuity', [
        { test: 'C/G', od: data.visualAcuity.od_cg, os: data.visualAcuity.os_cg },
        { test: 'S/G', od: data.visualAcuity.od_sg, os: data.visualAcuity.os_sg },
        { test: 'P/H', od: data.visualAcuity.od_ph, os: data.visualAcuity.os_ph }
    ], yPos, [
        { label: 'Test', key: 'test' },
        { label: 'OD', key: 'od' },
        { label: 'OS', key: 'os' }
    ]);

    // Additional Visual Tests
    if (data.visualAcuity.ct || data.visualAcuity.npc || data.visualAcuity.om) {
        yPos = addSection(' Accessory Tests',
            `CT: ${data.visualAcuity.ct || '-'}, ` +
            `NPC: ${data.visualAcuity.npc || '-'}, ` +
            `OM: ${data.visualAcuity.om || '-'}`, 
            yPos,
          
          );
    }
 



        // Check for page break
        if (yPos > 250) {
          doc.addPage();
          yPos = 20;
      }


    // Fundus Examination
    if (data.patientInfo.fundi) {
        yPos = addSection('Fundus Examination', data.patientInfo.fundi, yPos);
    }


      //Hb Rx

      if (data.hbrx) {
        const hbRxData = [
            { eye: 'OD', 
              sph: data.hbrx.hb_od_sph, 
              cyl: data.hbrx.hb_od_cyl, 
              axis: data.hbrx.hb_od_axis, 
              vision: data.hbrx.hb_od_vision },
            { eye: 'OS', 
              sph: data.hbrx.hb_os_sph, 
              cyl: data.hbrx.hb_os_cyl, 
              axis: data.hbrx.hb_os_axis, 
              vision: data.hbrx.hb_os_vision }
        ];

        yPos = addExamTable('Hb Rx', hbRxData, yPos, [
            { label: 'Eye', key: 'eye' },
            { label: 'Sph', key: 'sph' },
            { label: 'Cyl', key: 'cyl' },
            { label: 'Axis', key: 'axis' },
            { label: 'Vision', key: 'vision' }
        ]);
      }



    // Refraction and Hb Rx
    const refractionData = [
        { eye: 'OD', 
          sph: data.refraction.od_sph, 
          cyl: data.refraction.od_cyl, 
          axis: data.refraction.od_axis, 
          vision: data.refraction.od_vision },
        { eye: 'OS', 
          sph: data.refraction.os_sph, 
          cyl: data.refraction.os_cyl, 
          axis: data.refraction.os_axis, 
          vision: data.refraction.os_vision }
    ];

    yPos = addExamTable('Refraction', refractionData, yPos, [
        { label: 'Eye', key: 'eye' },
        { label: 'Sph', key: 'sph' },
        { label: 'Cyl', key: 'cyl' },
        { label: 'Axis', key: 'axis' },
        { label: 'Vision', key: 'vision' }
    ]);



    // Follow Up
    yPos = addSection('Follow Up', 
        `Needed: ${data.followUp.needed ? 'Yes' : 'No'}` +
        (data.followUp.needed ? `, Date: ${data.followUp.date}` : '') +
        (data.followUp.remarks ? `\nRemarks: ${data.followUp.remarks}` : ''), 
        yPos);

    // Footer
    doc.setFontSize(9);
    doc.setTextColor(100);
    doc.text('"Vision for Knowledge and Survival"', 105, 287, { align: 'center' });
    doc.text('© AKLO Vision Center', 105, 292, { align: 'center' });

    // Save PDF
    doc.save(`EyeExam_${data.patientInfo.name.replace(/\s+/g, '_')}_${data.patientInfo.date.replace(/\//g, '-')}.pdf`);
};








//fetch all the eye exam report

useEffect(() => {
  const fetchEyeExamRecords = async () => {
    if (selectedOption === "viewEyeExam") {
      try {
        const querySnapshot = await getDocs(collection(db, 'eyeExams'));
        const records = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setEyeExamRecords(records);
      } catch (error) {
        console.error("Error fetching eye exam records: ", error);
      }
    }
  };

  fetchEyeExamRecords();
}, [selectedOption]);






const filteredRecords = eyeExamRecords.filter(record => {
  // Search term filtering
  const matchesSearch = 
    record.patientInfo?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    record.patientInfo?.id?.toLowerCase().includes(searchTerm.toLowerCase());
  
  // Date filtering
  const recordDate = new Date(record.patientInfo?.date);
  const today = new Date();
  
  let matchesDate = true;
  if (filterOption === 'today') {
    matchesDate = recordDate.toDateString() === today.toDateString();
  } else if (filterOption === 'week') {
    const weekAgo = new Date();
    weekAgo.setDate(weekAgo.getDate() - 7);
    matchesDate = recordDate >= weekAgo;
  } else if (filterOption === 'month') {
    const monthAgo = new Date();
    monthAgo.setMonth(monthAgo.getMonth() - 1);
    matchesDate = recordDate >= monthAgo;
  }
  
  return matchesSearch && matchesDate;
});











// //patient's eye examination report

// const generatePatientEyeExam = (data) => {
//   const doc = new jsPDF({
//       orientation: 'portrait',
//       unit: 'mm',
//       format: 'a4',
//   });

//   // Set default font styles
//   doc.setFont('helvetica');
//   doc.setTextColor(0, 0, 0); // Black text

//   // Constants for layout
//   const leftMargin = 15;
//   const rightMargin = 15;
//   const pageWidth = 210 - leftMargin - rightMargin;
//   const column1 = leftMargin;
//   const column2 = 100;
//   const columnWidth = 80;

//   // Header Section
//   doc.addImage('/logo192.png', 'PNG', leftMargin, 10, 20, 20); // Larger logo
//   doc.setFontSize(14);
//   doc.setFont('helvetica', 'bold');
//   doc.text('AKLO VISION CENTER', leftMargin + 25, 18);
//   doc.setFontSize(10);
//   doc.text('No. 139/B, Hospital Rd, Kalubowila', leftMargin + 25, 23);
//   doc.text('Tel: 011 276 4677', leftMargin + 25, 28);
//   doc.text(`Date: ${data.patientInfo.date}`, 180, 18, { align: 'right' });
//   doc.line(leftMargin, 32, 210 - rightMargin, 32); // Horizontal line

//   // Report Title
//   doc.setFontSize(16);
//   doc.setFont('helvetica', 'bold');
//   doc.text('EYE EXAMINATION REPORT', 105, 42, { align: 'center' });
//   doc.setFontSize(10);
//   doc.setFont('helvetica', 'normal');

//   // Patient Information (Two Columns)
//   doc.setFontSize(12);
//   doc.setFont('helvetica', 'bold');
//   doc.text('PATIENT INFORMATION', leftMargin, 50);
//   doc.setFontSize(10);
//   doc.setFont('helvetica', 'normal');
  
//   // Column 1
//   doc.text(`Name: ${data.patientInfo.name}`, column1, 56);
//   doc.text(`Patient ID: ${data.patientInfo.id || 'N/A'}`, column1, 62);
//   doc.text(`Age: ${data.patientInfo.age || 'N/A'}`, column1, 68);
//   doc.text(`Gender: ${data.patientInfo.gender || 'N/A'}`, column1, 74);
  
//   // Column 2
//   doc.text(`Contact: ${data.patientInfo.contactNo || 'N/A'}`, column2, 56);
//   doc.text(`Email: ${data.patientInfo.email || 'N/A'}`, column2, 62);
//   doc.text(`DOB: ${data.patientInfo.dob || 'N/A'}`, column2, 68);
//   doc.line(leftMargin, 78, 210 - rightMargin, 78); // Divider line

//   // Helper functions
//   const addSection = (title, content, y, maxWidth = pageWidth) => {
//       doc.setFontSize(11);
//       doc.setFont('helvetica', 'bold');
//       doc.text(title.toUpperCase(), leftMargin, y);
//       doc.setFontSize(10);
//       doc.setFont('helvetica', 'normal');
      
//       const lines = doc.splitTextToSize(content || 'N/A', maxWidth);
//       doc.text(lines, leftMargin + 5, y + 6);
//       return y + (lines.length * 5) + 10;
//   };

//   const addExamTable = (title, data, y, columns) => {
//       doc.setFontSize(11);
//       doc.setFont('helvetica', 'bold');
//       doc.text(title.toUpperCase(), leftMargin, y);
//       y += 6;
      
//       // Table header
//       doc.setFontSize(10);
//       doc.setFont('helvetica', 'bold');
//       columns.forEach((col, i) => {
//           doc.text(col.label, leftMargin + (i * 40), y);
//       });
//       y += 6;
      
//       // Table data
//       doc.setFont('helvetica', 'normal');
//       data.forEach(row => {
//           columns.forEach((col, i) => {
//               doc.text(row[col.key] || 'N/A', leftMargin + (i * 40), y);
//           });
//           y += 6;
//       });
      
//       return y + 6;
//   };

//   let yPos = 82;

//   // History Sections
//   yPos = addSection('Chief Complaint', data.history.chiefComplaint, yPos);
//   yPos = addSection('History of Present Complaint', data.history.hpc, yPos);
//   yPos = addSection('Past Ocular History', data.history.pastOcularHistory, yPos);
//   yPos = addSection('Medical History', data.history.medicalHistory, yPos);
//   yPos = addSection('Family Ocular History', data.history.familyOcularHistory, yPos);
//   yPos = addSection('Social History', data.history.socialHistory, yPos);

//   // Check for page break
//   if (yPos > 250) {
//       doc.addPage();
//       yPos = 20;
//   }

//   // External Examination
//   yPos = addExamTable('External Examination', [
//       { label: 'Lids', od: data.externalExam.lids, os: data.externalExam.lids },
//       { label: 'Conjunctiva', od: data.externalExam.conjunctiva, os: data.externalExam.conjunctiva },
//       { label: 'Cornea', od: data.externalExam.cornea, os: data.externalExam.cornea },
//       { label: 'Sclera', od: data.externalExam.sclera, os: data.externalExam.sclera },
//       { label: 'A/C', od: data.externalExam.ac, os: data.externalExam.ac },
//       { label: 'Lens', od: data.externalExam.lens, os: data.externalExam.lens },
//       { label: 'Vitreous', od: data.externalExam.vitreous, os: data.externalExam.vitreous }
//   ], yPos, [
//       { label: 'Structure', key: 'label' },
//       { label: 'OD', key: 'od' },
//       { label: 'OS', key: 'os' }
//   ]);

//   // Family History
//   yPos = addSection('Family History', 
//       `POAG: ${data.familyHistory.poag ? 'Yes' : 'No'}, ` +
//       `AMD: ${data.familyHistory.amd ? 'Yes' : 'No'}, ` +
//       `DM: ${data.familyHistory.dm ? 'Yes' : 'No'}` +
//       (data.familyHistory.other ? `, Other: ${data.familyHistory.other}` : ''), 
//       yPos);

//   // Visual Acuity
//   yPos = addExamTable('Visual Acuity', [
//       { test: 'C/G', od: data.visualAcuity.od_cg, os: data.visualAcuity.os_cg },
//       { test: 'S/G', od: data.visualAcuity.od_sg, os: data.visualAcuity.os_sg },
//       { test: 'P/H', od: data.visualAcuity.od_ph, os: data.visualAcuity.os_ph }
//   ], yPos, [
//       { label: 'Test', key: 'test' },
//       { label: 'OD', key: 'od' },
//       { label: 'OS', key: 'os' }
//   ]);

//   // Additional Visual Tests
//   if (data.visualAcuity.ct || data.visualAcuity.npc || data.visualAcuity.om) {
//       yPos = addSection(' Accessory Tests',
//           `CT: ${data.visualAcuity.ct || 'N/A'}, ` +
//           `NPC: ${data.visualAcuity.npc || 'N/A'}, ` +
//           `OM: ${data.visualAcuity.om || 'N/A'}`, 
//           yPos,
        
//         );
//   }




//   // Follow Up
//   yPos = addSection('Follow Up', 
//       `Needed: ${data.followUp.needed ? 'Yes' : 'No'}` +
//       (data.followUp.needed ? `, Date: ${data.followUp.date}` : '') +
//       (data.followUp.remarks ? `\nRemarks: ${data.followUp.remarks}` : ''), 
//       yPos);

//   // Footer
//   doc.setFontSize(9);
//   doc.setTextColor(100);
//   doc.text('"Vision for Knowledge and Survival"', 105, 287, { align: 'center' });
//   doc.text('© AKLO Vision Center', 105, 292, { align: 'center' });

//   // Save PDF
//   doc.save(`EyeExam_${data.patientInfo.name.replace(/\s+/g, '_')}_${data.patientInfo.date.replace(/\//g, '-')}.pdf`);
// };





//patient's eye examination report
const generatePatientEyeExam = (data) => {
  const doc = new jsPDF({
    orientation: 'portrait',
    unit: 'mm',
    format: 'a4',
  });

  // Set default font styles
  doc.setFont('helvetica');
  doc.setTextColor(0, 0, 0); // Black text

  // Constants for layout
  const leftMargin = 15;
  const rightMargin = 15;
  const pageWidth = 210 - leftMargin - rightMargin;
  const column1 = leftMargin;
  const column2 = 100;
  const columnWidth = 80;

  // Header Section
  doc.addImage('/new-logo-aklo.png', 'PNG', leftMargin, 10, 20, 20);
  doc.setFontSize(14);
  doc.setFont('helvetica', 'bold');
  doc.text('AKLO VISION CENTER', leftMargin + 25, 18);
  doc.setFontSize(10);
  doc.text('No. 139/B, Hospital Rd, Kalubowila', leftMargin + 25, 23);
  doc.text('Tel: 011 276 4677', leftMargin + 25, 28);
  doc.text(`Date: ${data.patientInfo.date}`, 180, 18, { align: 'right' });
  doc.line(leftMargin, 32, 210 - rightMargin, 32);

  // Report Title
  doc.setFontSize(16);
  doc.setFont('helvetica', 'bold');
  doc.text('EYE EXAMINATION REPORT', 105, 42, { align: 'center' });
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');

  // Patient Information (Two Columns)
  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.text('PATIENT INFORMATION', leftMargin, 50);
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  
  // Column 1
  doc.text(`Name: ${data.patientInfo.name}`, column1, 56);
  doc.text(`Patient ID: ${data.patientInfo.id || '-'}`, column1, 62);
  doc.text(`Age: ${data.patientInfo.age || '-'}`, column1, 68);
  doc.text(`Gender: ${data.patientInfo.gender || '-'}`, column1, 74);
  
  // Column 2
  doc.text(`Contact: ${data.patientInfo.contactNo || '-'}`, column2, 56);
  doc.text(`Email: ${data.patientInfo.email || '-'}`, column2, 62);
  doc.text(`DOB: ${data.patientInfo.dob || '-'}`, column2, 68);
  doc.line(leftMargin, 78, 210 - rightMargin, 78);

  // Helper functions
  const addSection = (title, content, y, maxWidth = pageWidth) => {
    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');
    doc.text(title.toUpperCase(), leftMargin, y);
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    
    const lines = doc.splitTextToSize(content || '-', maxWidth);
    doc.text(lines, leftMargin + 5, y + 6);
    return y + (lines.length * 5) + 10;
  };

  const addCompactExamTable = (title, data, y, columns) => {
    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');
    doc.text(title.toUpperCase(), leftMargin, y);
    y += 6;
    
    // Table header
    doc.setFontSize(9);
    doc.setFont('helvetica', 'bold');
    columns.forEach((col, i) => {
      doc.text(col.label, leftMargin + (i * (pageWidth/columns.length)), y);
    });
    y += 4;
    
    // Table data
    doc.setFont('helvetica', 'normal');
    data.forEach(row => {
      columns.forEach((col, i) => {
        doc.text(row[col.key] || '-', leftMargin + (i * (pageWidth/columns.length)), y);
      });
      y += 4;
    });
    
    return y + 6;
  };

  const addTwoColumnSection = (title, leftContent, rightContent, y) => {
    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');
    doc.text(title.toUpperCase(), leftMargin, y);
    y += 6;
    
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    
    // Left column
    const leftLines = doc.splitTextToSize(leftContent || '-', columnWidth);
    doc.text(leftLines, column1, y + 6);
    
    // Right column
    const rightLines = doc.splitTextToSize(rightContent || '-', columnWidth);
    doc.text(rightLines, column2, y + 6);
    
    return y + Math.max(leftLines.length, rightLines.length) * 5 + 10;
  };

  let yPos = 82;

  // History Sections - arranged in two columns
  yPos = addTwoColumnSection(
    'Chief Complaint & History of Present Complaint',
    `Chief Complaint:\n${data.history.chiefComplaint || '-'}`,
    `History of Present Complaint:\n${data.history.hpc || '-'}`,
    yPos
  );

  yPos = addTwoColumnSection(
    'Past & Family Ocular History',
    `Past Ocular History:\n${data.history.pastOcularHistory || '-'}`,
    `Family Ocular History:\n${data.history.familyOcularHistory || '-'}`,
    yPos
  );

  yPos = addTwoColumnSection(
    'Medical & Social History',
    `Medical History:\n${data.history.medicalHistory || '-'}`,
    `Social History:\n${data.history.socialHistory || '-'}`,
    yPos
  );

  // Check for page break
  if (yPos > 250) {
    doc.addPage();
    yPos = 20;
  }

  // External Examination - more compact table
  yPos = addCompactExamTable('External Examination', [
  { structure: 'Lids', left: lidsLeft || '-', right: lidsRight || '-' },
  { structure: 'Conjunctiva', left: conjunctivaLeft || '-', right: conjunctivaRight || '-' },
  { structure: 'Cornea', left: corneaLeft || '-', right: corneaRight || '-' },
  { structure: 'Sclera', left: scleraLeft || '-', right: scleraRight || '-' },
  { structure: 'A/C', left: acLeft || '-', right: acRight || '-' },
  { structure: 'Lens', left: lensLeft || '-', right: lensRight || '-' },
  { structure: 'Vitreous', left: vitreousLeft || '-', right: vitreousRight || '-' }
], yPos, [
  { label: 'Structure', key: 'structure' },
  { label: 'Left Eye', key: 'left' },
  { label: 'Right Eye', key: 'right' }
]);

  // Family History and Visual Acuity in two columns
  yPos = addTwoColumnSection(
    'Family History & Visual Acuity',
    `Family History:\nPOAG: ${data.familyHistory.poag ? 'Yes' : 'No'}\nAMD: ${data.familyHistory.amd ? 'Yes' : 'No'}\nDM: ${data.familyHistory.dm ? 'Yes' : 'No'}\nOther: ${data.familyHistory.other || '-'}`,
    `Visual Acuity:\nC/G - OD: ${data.visualAcuity.od_cg || '-'} OS: ${data.visualAcuity.os_cg || '-'}\nS/G - OD: ${data.visualAcuity.od_sg || '-'} OS: ${data.visualAcuity.os_sg || '-'}\nP/H - OD: ${data.visualAcuity.od_ph || '-'} OS: ${data.visualAcuity.os_ph || '-'}`,
    yPos
  );


      // Fundus Examination
    if (data.patientInfo.fundi) {
        yPos = addSection('Fundus Examination', data.patientInfo.fundi, yPos);
    }
  // Additional Visual Tests and Follow Up in two columns
  yPos = addTwoColumnSection(
    'Accessory Tests & Follow Up',
    `Accessory Tests:\nCT: ${data.visualAcuity.ct || '-'}\nNPC: ${data.visualAcuity.npc || '-'}\nOM: ${data.visualAcuity.om || '-'}`,
    `Follow Up:\nNeeded: ${data.followUp.needed ? 'Yes' : 'No'}\nDate: ${data.followUp.date || '-'}\nRemarks: ${data.followUp.remarks || '-'}`,
    yPos
  );

  // Footer
  doc.setFontSize(9);
  doc.setTextColor(100);
  doc.text('"Vision for Knowledge and Survival"', 105, 287, { align: 'center' });
  doc.text('© AKLO Vision Center', 105, 292, { align: 'center' });

  // Save PDF
  doc.save(`EyeExam_${data.patientInfo.name.replace(/\s+/g, '_')}_${data.patientInfo.date.replace(/\//g, '-')}.pdf`);
};














  const [notifications, setNotifications] = useState([]);
  const [todayCount, setTodayCount] = useState(0);
  const [error, setError] = useState(null);

  // Helper function to convert date to readable format
  const formatDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
  };

  // Helper function to check if date is today
  const isToday = (date) => {
    if (!date) return false;
    const d = new Date(date);
    const today = new Date();
    return (
      d.getDate() === today.getDate() &&
      d.getMonth() === today.getMonth() &&
      d.getFullYear() === today.getFullYear()
    );
  };

  // Helper function to get days difference
  const getDaysDifference = (date) => {
    if (!date) return 0;
    const d = new Date(date);
    const today = new Date();
    const diffTime = d - today;
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  };

  useEffect(() => {
    const fetchFollowUpDates = async () => {
      try {
        const patientsRef = collection(db, 'patients');
        const q = query(
          patientsRef,
          where("followUpDate", "!=", null),
          orderBy("followUpDate", "asc")
        );
        
        const querySnapshot = await getDocs(q);
        const fetchedNotifications = [];
        let todayNotifications = 0;

        querySnapshot.forEach((doc) => {
          const patientData = doc.data();
          const followUpDate = patientData.followUpDate;
          
          // Convert Firestore Timestamp to Date if needed
          const dateValue = followUpDate.toDate ? followUpDate.toDate() : new Date(followUpDate);
          
const notification = {
  ...patientData,
  id: doc.id,
  patientName: patientData.name || 'Unknown Patient',
  followUpDate: dateValue, // this now overwrites any raw version from Firestore
  formattedDate: formatDate(dateValue),
  isToday: isToday(dateValue),
  daysDifference: getDaysDifference(dateValue),
  status: patientData.status || 'pending',
};

          
          // Only show future or today's notifications
          if (notification.daysDifference >= 0) {
            fetchedNotifications.push(notification);
            if (notification.isToday) todayNotifications++;
          }
        });

        setNotifications(fetchedNotifications);
        setTodayCount(todayNotifications);
      } catch (err) {
        console.error("Error fetching notifications:", err);
        setError("Failed to load notifications. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchFollowUpDates();
  }, []);

  const getPriorityColor = (date) => {
    if (!date) return '#52c41a';
    const today = new Date();
    const diffInDays = getDaysDifference(date);
    
    if (isToday(date)) return '#ff4d4f'; // Red for today
    if (diffInDays <= 3) return '#faad14'; // Yellow for upcoming 3 days
    return '#52c41a'; // Green for future dates
  };


/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  return (


    <div className="hero-dashboard-container">
      {/* Left Sidebar */}
      <div className="lecturer-sidebar">
      <div className="home-content">
              <img
                src="/new-logo-aklo.png" // Assuming the image is in the public folder
                alt="Aklo Eye Care"
                className="left-panel-image"
              />
              </div>
        <h2 className="lecturer-sidebar-title">Aklo Vision Center</h2>

        <div className="lecturer-sidebar-list">
        <li onClick={() => setSelectedOption("addPatient")}>Add Patient</li>
        <li onClick={() => setSelectedOption("viewPatients")}>View All Patients</li>
          <li onClick={() => setSelectedOption("createInvoice")}>Create Invoice</li>
          <li onClick={() => setSelectedOption("viewInvoice")}>View Previous Invoice</li>
          <li onClick={() => setSelectedOption("consultation")}>Create Consultation Invoice</li>
          <li onClick={() => setSelectedOption("previousConsultation")}>View Previous Consultation</li>
          <li onClick={() => setSelectedOption("eyeExam")}>Create Eye Exam Report</li>
          <li onClick={() => setSelectedOption("viewEyeExam")}>View All Eye Exam Report</li>
          <li onClick={() => setSelectedOption("patienteyeExam")}>Eye Exam Report For Patient</li>
          <li onClick={() => setSelectedOption("notification")}>Patient Follow-Ups</li>
          <li className="logout-button" onClick={handleLogout}>Logout</li>
        </div>
      </div>

      {/* Main Panel */}
      <div className="lecturer-panel">

        {selectedOption === "addPatient" && (
          <div className="patient-form-question">
          <h1 className="lecturer-panel-title">Add Patient</h1>
          <form onSubmit={handleSubmit} className="patient-form-container">
            <div className="form-group">
              <label>Name:</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Date of Birth:</label>
              <input
                type="date"
                name="dateOfBirth"
                value={formData.dateOfBirth}
                onChange={handleChange}
             
              />
            </div>

            <div className="form-group">
              <label>Sex:</label>
              <select
                name="sex"
                value={formData.sex}
                onChange={handleChange}
                required
              >
                <option value="">Select Gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
              </select>
            </div>

            <div className="form-group">
              <label>Telephone No:</label>
              <input
                type="tel"
                name="telephoneNo"
                value={formData.telephoneNo}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Address:</label>
              <textarea
                name="address"
                value={formData.address}
                onChange={handleChange}
                required
              />
            </div>

            <button type="submit" className="submit-btn">Add Patient</button>
          </form>
        </div>
        )}




       {selectedOption === "viewPatients" && (
    <div className="patients-section">
    <h1 className="lecturer-panel-title">View All Patients</h1>
    
    {loading ? (
      <div className="loading-spinner">Loading...</div>
    ) : patients.length === 0 ? (
      <p className="no-patients">No patients found in the database.</p>
    ) : (
      <div className="patients-table-container">
        <table className="patients-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Date of Birth</th>
              <th>Sex</th>
              <th>Telephone</th>
              <th>Address</th>
            </tr>
          </thead>
          <tbody>
            {patients.map(patient => (
              <tr key={patient.id}>
                <td>{patient.name}</td>
                <td>{patient.dateOfBirth}</td>
                <td>{patient.sex}</td>
                <td>{patient.telephoneNo}</td>
                <td>{patient.address}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </div>
        )}




          {selectedOption === "createInvoice" && userDetails && (
            <div className="student-dashboard-container">
            <div className="lecturer-panel">
              {selectedOption === "createInvoice" && userDetails && (
                <div className="home-section">
                  <h1 className="invoice-heading">Create Invoice</h1>
                  <form className="invoice-form">
                    <div className="form-row-create-invoice">

                      <div className="form-column-create-invoice">
                        <label htmlFor="to">Patient Name</label>
                        <input
                        type="text"
                        className="form-column-create-invoice"
                          id="to" 
                          value={to} 
                          onChange={(e) => setTo(e.target.value)} 
                          required
                        />
                         
                      </div>

                      <div className="form-column-create-invoice">
                        <label htmlFor="date">Date</label>
                        <input type="date" id="date" value={date} onChange={(e) => setDate(e.target.value)} required />
                      </div>
                    </div>

                    <div className="form-row-create-invoice">

                      <div className="form-column-create-invoice">
                        <label htmlFor="invoiceNo">Invoice No</label>
                        <input type="text" id="invoiceNo" value={invoiceNumber} onChange={(e) => setInvoiceNumber(e.target.value)} required />
                      </div>
                      
            


                      <div className="form-column-create-invoice">
                        <label htmlFor="amount">Amount</label>
                        <input
                          type="number"
                          id="amount"
                          value={amount}
                          onChange={(e) => {
                            const value = e.target.value;
                            setAmount(value);
                            setTotalAmount(parseFloat(value) - parseFloat(deductAmount) || 0); // Adjust total amount calculation
                          }}
                          required
                        />
                      </div>
                    </div>

                    <div className="form-row-create-invoice">
                      <div className="form-column-create-invoice">
                        <label htmlFor="deductAmount">Advance Payment</label>
                        <input
                          type="number"
                          id="deductAmount"
                          value={deductAmount}
                          onChange={(e) => {
                            const value = e.target.value;
                            setDeductAmount(value);
                            setTotalAmount(parseFloat(amount) - parseFloat(value)); // Adjust total amount calculation
                          }}
                        />
                      </div>
                    </div>

                    <div className="form-row-create-invoice">
                      <div className="form-column-create-invoice">
                        <label htmlFor="description">Description</label>
                        <textarea id="description" value={description} onChange={(e) => setDescription(e.target.value)} required />
                      </div>
                    </div>

                    <div className="form-row-create-invoice">
                      <div className="form-column-create-invoice">
                        <label htmlFor="totalAmount">Balance Amount</label>
                        <input type="text" id="totalAmount" value={totalAmount} readOnly />
                      </div>
                    </div>

                    <button type="button" onClick={handleCreateInvoice} className="create-button">
                      Create Invoice
                    </button>
                  </form>
                </div>
              )}
            </div>
            </div>
           )}




              {/* {selectedOption === "viewInvoice" && (
                <div className="home-section">

                <div className="invoice-header-container">
                  <h1 className="view-all-invoice-heading">View All Invoices</h1>
                  <button onClick={handleDownload} className="invoices-d-button">
                    Download Invoices
                  </button>
                </div>

                  <div className="invoices-container"> 
                    <table className="invoices-table">
                      <thead>
                        <tr>
                          <th>Invoice Number</th>
                          <th>To</th>
                          <th>Date</th>
                          <th>Description</th>
                          <th>Amount</th>
                          <th>Deduction Amount</th>
                          <th>Total Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {invoices.length > 0 ? (
                          invoices.map((invoice) => (
                            <tr key={invoice.id}>
                              <td>{invoice.invoiceNo}</td>
                              <td>{invoice.to}</td>
                              <td>{invoice.date}</td>
                              <td>{invoice.description}</td>
                              <td>{invoice.amount}</td>
                              <td>{invoice.deductAmount}</td>
                              <td>{invoice.totalAmount}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5">No invoices found.</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              )} */}

{selectedOption === "viewInvoice" && (
  <div className="home-section">
    <div className="invoice-header-container">
      <h1 className="view-all-invoice-heading">View All Invoices</h1>

      <div className="invoice-actions">
        <input
          type="text"
          placeholder="Search by name or invoice number..."
          className="invoice-search"
          onChange={(e) => setSearchTerm(e.target.value)}
          value={searchTerm}
        />
        <button onClick={handleDownload} className="export-button">
          Export All Invoices
        </button>
      </div>

    </div>

    <div className="invoices-container"> 
      <table className="invoices-table">
        <thead>
          <tr>
            <th>Invoice Number</th>
            <th>To</th>
            <th>Date</th>
            <th>Description</th>
            <th>Amount</th>
            <th>Deduction Amount</th>
            <th>Total Amount</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredInvoices.length > 0 ? (
            filteredInvoices.map((invoice) => (
              <tr key={invoice.id}>
                <td>{invoice.invoiceNo}</td>
                <td>{invoice.to}</td>
                <td>{invoice.date}</td>
                <td>{invoice.description}</td>
                <td>{invoice.amount}</td>
                <td>{invoice.deductAmount}</td>
                <td>{invoice.totalAmount}</td>
                {/* <td>
                  <button 
                    onClick={() => generatePDF(invoice)}
                    className="download-pdf-button"
                  >
                    Download Invoice
                  </button>
                </td> */}


                      <td>
                        <div className="invoice-actions-container">
                          <button 
                            onClick={() => generatePDF(invoice)}
                            className="download-pdf-button"
                          >
                            Download
                          </button>
                          <button 
                            onClick={() => handleDeleteInvoice(invoice.id)}
                            className="delete-button"
                          >
                            Delete
                          </button>
                        </div>
                      </td>


              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8">No invoices found.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
)}





              

{selectedOption === "viewPatients" && (
  <div className="patients-section">
    <div className="patients-header">
      <h1 className="lecturer-panel-title">View All Patients</h1>
      <button onClick={handleDownloadPatients} className="patients-excel">
          Export to Excel
        </button>
      <div className="patients-actions">
        <input
          type="text"
          placeholder="Search by name..."
          className="patient-search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

      </div>
    </div>

    {loading ? (
      <div className="loading-spinner">Loading...</div>
    ) : filteredPatients.length === 0 ? (
      <p className="no-patients">
        {searchTerm ? "No matching patients found" : "No patients found in the database"}
      </p>
    ) : (
      <div className="patients-table-container">
        <table className="patients-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Date of Birth</th>
              <th>Sex</th>
              <th>Telephone</th>
              <th>Address</th>
              <th>Follow Up Date</th>
              <th>Follow Up Description</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredPatients.map(patient => (
              <tr key={patient.id}>
                <td>{patient.name}</td>
                <td>{patient.dateOfBirth}</td>
                <td>{patient.sex}</td>
                <td>{patient.telephoneNo}</td>
                <td>{patient.address}</td>
                <td>{patient.followUpDate || "N/A"}</td>
                <td>{patient.followUpDescription}</td>


                <td>
                  <div className="patient-actions-container">
                    <button 
                      onClick={() => setEditingPatient(patient)}
                      className="edit-patient-btn"
                    >
                      Edit
                    </button>
                    <button 
                      onClick={() => handleDeletePatient(patient.id)}
                      className="delete-patient-btn"
                    >
                      Delete
                    </button>
                  </div>
                </td>


              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}

    {/* Edit Patient Modal */}
    {editingPatient && (
      <div className="modal-overlay">
        <div className="edit-patient-modal">
          <h2>Edit Patient Details</h2>
          <form onSubmit={handleUpdatePatient}>
            <div className="form-group">
              <label>Name:</label>
              <input
                type="text"
                value={editingPatient.name || ""}
                onChange={(e) => setEditingPatient({...editingPatient, name: e.target.value})}
                required
              />
            </div>
            
            {/* Include all other patient fields similarly */}
            
            <div className="form-group">
              <label>Follow Up Date:</label>
              <input
                type="date"
                value={editingPatient.followUpDate || ""}
                onChange={(e) => setEditingPatient({...editingPatient, followUpDate: e.target.value})}
              />
            </div>
            
            <div className="form-group">
              <label>Follow Up Description:</label>
              <textarea
                value={editingPatient.followUpDescription || ""}
                onChange={(e) => setEditingPatient({...editingPatient, followUpDescription: e.target.value})}
                rows="3"
              />
            </div>
            
            <div className="modal-actions">
              <button type="button" className="cancel-btn-patient" onClick={() => setEditingPatient(null)}>
                Cancel
              </button>
              <button type="submit" className="save-btn-patient">
                Save Changes
              </button>
            </div>
          </form>
        </div>
      </div>
    )}
  </div>
)}


















{selectedOption === "consultation" && (
  <div className="student-dashboard-container">
    <div className="lecturer-panel">
      <div className="home-section">
        <h1 className="invoice-heading">Consultation Invoice</h1>
        <form className="invoice-form">
          <div className="form-row-create-invoice">
            <div className="form-column-create-invoice">
              <label htmlFor="invoiceNo">Invoice No</label>
              <input
                type="text"
                id="invoiceNo"
                value={invoiceNumber}
                onChange={(e) => setInvoiceNumber(e.target.value)}
                placeholder="INV-001"
                required
              />
            </div>
            <div className="form-column-create-invoice">
              <label htmlFor="date">Date</label>
              <input
                type="date"
                id="date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="form-row-create-invoice">
            <div className="form-column-create-invoice">
              <label htmlFor="to">Patient Name</label>
              <input
                type="text"
                id="to"
                value={to}
                onChange={(e) => setTo(e.target.value)}
                placeholder="Enter patient name"
                required
              />
            </div>
          </div>

          <div className="form-row-create-invoice">
            <div className="form-column-create-invoice">
              <label htmlFor="description">Description</label>
              <textarea
                id="description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Consultation details"
                rows={3}
                required
              />
            </div>
          </div>

          <div className="form-row-create-invoice">
            <div className="form-column-create-invoice">
              <label htmlFor="amount">Amount (Rs.)</label>
              <input
                type="number"
                id="amount"
                value={amount}
                onChange={(e) => {
                  const value = e.target.value;
                  setAmount(value);
                  setTotalAmount(parseFloat(value) - parseFloat(deductAmount) || 0);
                }}
                placeholder="0.00"
                min="0"
                step="0.01"
                required
              />
            </div>

          </div>

          <div className="form-row-create-invoice">
            <div className="form-column-create-invoice">
              <label htmlFor="totalAmount">Total Amount (Rs.)</label>
              <input
                type="text"
                id="totalAmount"
                value={(parseFloat(amount || 0) - parseFloat(deductAmount || 0)).toFixed(2)}
                readOnly
              />
            </div>
          </div>

          <button
            type="button"
            onClick={handleCreateConsultationInvoice}
            className="create-button"
          >
            Create Consultation Invoice
          </button>
        </form>
      </div>
    </div>
  </div>
)}


{selectedOption === "previousConsultation" && (
  <div className="salary-table-container">
    <h1 className="lecturer-panel-title">View Previous Consultation</h1>
    
    <div className="table-responsive">
      <table className="invoice-table">
        <thead>
          <tr>
            <th>Invoice No</th>
            <th>Date</th>
            <th>Patient Name</th>
            <th>Description</th>
            <th>Amount (Rs.)</th>
            <th>Total Amount (Rs.)</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {consultationInvoices.map((invoice) => (
            <tr key={invoice.id}>
              <td>{invoice.invoiceNo}</td>
              <td>{invoice.date}</td>
              <td>{invoice.patientName}</td>
              <td className="description-cell">{invoice.description}</td>
              <td>{invoice.amount.toFixed(2)}</td>
              <td>{invoice.totalAmount.toFixed(2)}</td>
              <td>
                <button 
                  className="view-btn"
                  onClick={() => handleViewInvoice(invoice)}
                >
                  View
                </button>
  
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    
    {/* View Invoice Modal */}
    {selectedInvoice && (
      <div className="modal-overlay">
        <div className="modal-content">
          <div className="modal-header">
            <h2>Invoice Details</h2>
            <button 
              className="close-btn"
              onClick={() => setSelectedInvoice(null)}
            >
              &times;
            </button>
          </div>
          <div className="modal-body">
            <p><strong>Invoice No:</strong> {selectedInvoice.invoiceNo}</p>
            <p><strong>Date:</strong> {selectedInvoice.date}</p>
            <p><strong>Patient:</strong> {selectedInvoice.patientName}</p>
            <p><strong>Description:</strong> {selectedInvoice.description}</p>
            <p><strong>Amount:</strong> Rs. {selectedInvoice.amount.toFixed(2)}</p>
            <p><strong>Total Amount:</strong> Rs. {selectedInvoice.totalAmount.toFixed(2)}</p>
          </div>
        </div>
      </div>
    )}
  </div>
)}










{selectedOption === "eyeExam" && (
    <div className="eye-exam-section">
    <h1 className="lecturer-panel-title">Create Eye Exam Report</h1>
    
    <form onSubmit={handleEyeExamSubmit} className="eye-exam-form">
      {/* Patient Information */}
      <div className="form-section">
        <h2>Patient Information</h2>
        <div className="form-row">
          <div className="form-group">
            <label>Patient Name *</label>
            <input 
              type="text" 
              value={patientName}
              onChange={(e) => setPatientName(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label>Date *</label>
            <input 
              type="date" 
              value={examDate}
              onChange={(e) => setExamDate(e.target.value)}
              required
            />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label>Patient ID</label>
            <input 
              type="text" 
              value={patientId}
              onChange={(e) => setPatientId(e.target.value)}
            />

            <div className="form-group">
            <label>Date of Birth *</label>
            <input 
              type="date" 
              value={dob}
              onChange={(e) => setDob(e.target.value)}
              required
            />
          </div>

          </div>
          <div className="form-group">
            <label>Age</label>
            <input 
              type="text" 
              value={age}
              onChange={(e) => setAge(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Gender</label>
            <select 
              value={gender}
              onChange={(e) => setGender(e.target.value)}
            >
              <option value="">Select</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </select>
          </div>

          <div className="form-group">
            <label>Contact No</label>
            <input 
              type="text" 
              value={contactNo}
              onChange={(e) => setContactNo(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>Email Address</label>
            <input 
              type="text" 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

        </div>
      </div>

      {/* History Taking */}
      <div className="form-section">
        <h2>History Taking</h2>
        <div className="history-form-group">
          <label>Chief Complaint</label>
          <textarea 
            value={chiefComplaint}
            onChange={(e) => setChiefComplaint(e.target.value)}
            rows="2"
          />
        </div>
        <div className="history-form-group">
          <label>HPC (History of Present Complaint)</label>
          <textarea 
            value={hpc}
            onChange={(e) => setHpc(e.target.value)}
            rows="2"
          />
        </div>
        <div className="history-form-group">
          <label>Past Ocular History</label>
          <textarea 
            value={pastOcularHistory}
            onChange={(e) => setPastOcularHistory(e.target.value)}
            rows="2"
          />
        </div>
        <div className="history-form-group">
          <label>Medical History</label>
          <textarea 
            value={medicalHistory}
            onChange={(e) => setMedicalHistory(e.target.value)}
            rows="2"
          />
        </div>
        <div className="history-form-group">
          <label>Family Ocular History</label>
          <textarea 
            value={familyOcularHistory}
            onChange={(e) => setFamilyOcularHistory(e.target.value)}
            rows="2"
          />
        </div>
        <div className="history-form-group">
          <label>Social History</label>
          <textarea 
            value={socialHistory}
            onChange={(e) => setSocialHistory(e.target.value)}
            rows="2"
          />
        </div>
      </div>





{/* External Examination */}

{/* Lids */}
<div className="exam-form-group">
  <label>Lids</label>
  <div className="eye-inputs">
    <div>
      <label>Left Eye</label>
      <textarea
        value={lidsLeft}
        onChange={(e) => setLidsLeft(e.target.value)}
        rows="2"
        placeholder="Enter left eye lids condition"
      />
    </div>
    <div>
      <label>Right Eye</label>
      <textarea
        value={lidsRight}
        onChange={(e) => setLidsRight(e.target.value)}
        rows="2"
        placeholder="Enter right eye lids condition"
      />
    </div>
  </div>
</div>

{/* Conjunctiva */}
<div className="exam-form-group">
  <label>Conjunctiva</label>
  <div className="eye-inputs">
    <div>
      <label>Left Eye</label>
      <textarea
        value={conjunctivaLeft}
        onChange={(e) => setConjunctivaLeft(e.target.value)}
        rows="2"
        placeholder="Enter left eye conjunctiva condition"
      />
    </div>
    <div>
      <label>Right Eye</label>
      <textarea
        value={conjunctivaRight}
        onChange={(e) => setConjunctivaRight(e.target.value)}
        rows="2"
        placeholder="Enter right eye conjunctiva condition"
      />
    </div>
  </div>
</div>

{/* Cornea */}
<div className="exam-form-group">
  <label>Cornea</label>
  <div className="eye-inputs">
    <div>
      <label>Left Eye</label>
      <textarea
        value={corneaLeft}
        onChange={(e) => setCorneaLeft(e.target.value)}
        rows="2"
        placeholder="Enter left eye cornea condition"
      />
    </div>
    <div>
      <label>Right Eye</label>
      <textarea
        value={corneaRight}
        onChange={(e) => setCorneaRight(e.target.value)}
        rows="2"
        placeholder="Enter right eye cornea condition"
      />
    </div>
  </div>
</div>

{/* Sclera */}
<div className="exam-form-group">
  <label>Sclera</label>
  <div className="eye-inputs">
    <div>
      <label>Left Eye</label>
      <textarea
        value={scleraLeft}
        onChange={(e) => setScleraLeft(e.target.value)}
        rows="2"
        placeholder="Enter left eye sclera condition"
      />
    </div>
    <div>
      <label>Right Eye</label>
      <textarea
        value={scleraRight}
        onChange={(e) => setScleraRight(e.target.value)}
        rows="2"
        placeholder="Enter right eye sclera condition"
      />
    </div>
  </div>
</div>

{/* A/C (Anterior Chamber) */}
<div className="exam-form-group">
  <label>A/C (Anterior Chamber)</label>
  <div className="eye-inputs">
    <div>
      <label>Left Eye</label>
      <textarea
        value={acLeft}
        onChange={(e) => setAcLeft(e.target.value)}
        rows="2"
        placeholder="Enter left eye A/C condition"
      />
    </div>
    <div>
      <label>Right Eye</label>
      <textarea
        value={acRight}
        onChange={(e) => setAcRight(e.target.value)}
        rows="2"
        placeholder="Enter right eye A/C condition"
      />
    </div>
  </div>
</div>

{/* Lens */}
<div className="exam-form-group">
  <label>Lens</label>
  <div className="eye-inputs">
    <div>
      <label>Left Eye</label>
      <textarea
        value={lensLeft}
        onChange={(e) => setLensLeft(e.target.value)}
        rows="2"
        placeholder="Enter left eye lens condition"
      />
    </div>
    <div>
      <label>Right Eye</label>
      <textarea
        value={lensRight}
        onChange={(e) => setLensRight(e.target.value)}
        rows="2"
        placeholder="Enter right eye lens condition"
      />
    </div>
  </div>
</div>

{/* Vitreous */}
<div className="exam-form-group">
  <label>Vitreous</label>
  <div className="eye-inputs">
    <div>
      <label>Left Eye</label>
      <textarea
        value={vitreousLeft}
        onChange={(e) => setVitreousLeft(e.target.value)}
        rows="2"
        placeholder="Enter left eye vitreous condition"
      />
    </div>
    <div>
      <label>Right Eye</label>
      <textarea
        value={vitreousRight}
        onChange={(e) => setVitreousRight(e.target.value)}
        rows="2"
        placeholder="Enter right eye vitreous condition"
      />
    </div>
  </div>
</div>











      {/* Family History */}
      <div className="form-section">
        <h2>Family History</h2>
        <div className="checkbox-group">
          <label>
            <input 
              type="checkbox" 
              name="poag"
              checked={familyHistory.poag}
              onChange={handleFamilyHistoryChange}
            />
            FHx POAG
          </label>
          <label>
            <input 
              type="checkbox" 
              name="amd"
              checked={familyHistory.amd}
              onChange={handleFamilyHistoryChange}
            />
            FHx AMD
          </label>
          <label>
            <input 
              type="checkbox" 
              name="dm"
              checked={familyHistory.dm}
              onChange={handleFamilyHistoryChange}
            />
            FHx DM
          </label>
          <div className="custom-condition">
            <input 
              type="text" 
              name="other"
              value={familyHistory.other}
              onChange={handleFamilyHistoryChange}
              placeholder="Other family history"
            />
          </div>
        </div>
      </div>

      {/* Visual Acuity */}
      <div className="form-section">
        <h2>Visual Acuity</h2>
        <div className="va-grid">
          <div className="va-header">
            <div></div>
            <div>OD</div>
            <div>OS</div>
          </div>
          <div className="va-row">
            <div className="va-test">C∕G</div>
            <input 
              type="text" 
              name="od_cg"
              value={visualAcuity.od_cg}
              onChange={handleVisualAcuityChange}
            />
            <input 
              type="text" 
              name="os_cg"
              value={visualAcuity.os_cg}
              onChange={handleVisualAcuityChange}
            />
          </div>
          <div className="va-row">
            <div className="va-test">S∕G</div>
            <input 
              type="text" 
              name="od_sg"
              value={visualAcuity.od_sg}
              onChange={handleVisualAcuityChange}
            />
            <input 
              type="text" 
              name="os_sg"
              value={visualAcuity.os_sg}
              onChange={handleVisualAcuityChange}
            />
          </div>
          <div className="va-row">
            <div className="va-test">P∕H</div>
            <input 
              type="text" 
              name="od_ph"
              value={visualAcuity.od_ph}
              onChange={handleVisualAcuityChange}
            />
            <input 
              type="text" 
              name="os_ph"
              value={visualAcuity.os_ph}
              onChange={handleVisualAcuityChange}
            />
          </div>
        </div><br /><br />
        
        <div className="va-test">CT</div>
        <input 
              type="text" 
              name="ct"
              value={visualAcuity.ct}
              onChange={handleVisualAcuityChange}
            />
              <div className="va-test">NPC</div>
            <input 
              type="text" 
              name="npc"
              value={visualAcuity.npc}
              onChange={handleVisualAcuityChange}
            />
          <div className="va-test">OM</div>
           <input 
              type="text" 
              name="om"
              value={visualAcuity.om}
              onChange={handleVisualAcuityChange}
            />
      </div>



      {/* Fundi */}
      <div className="form-section">
        <h2>Fundi</h2>
        <div className="va-grid">
          <div className="form-group">
            <label>Description</label>
            <input 
              type="text" 
              value={fundi}
              onChange={(e) => setFundi(e.target.value)}
            />
          </div>
            </div>
      </div>






{/* Hb Rx */}
<div className="form-section">
        <h2>Hb Rx</h2>
        <div className="refraction-grid">
          <div className="refraction-header">
            <div></div>
            <div>Sph</div>
            <div>Cyl</div>
            <div>Axis</div>
            <div>Vision</div>
          </div>
          <div className="refraction-row">
            <div>OD</div>
            <input 
              type="text" 
              name="hb_od_sph"
              value={hbrx.hb_od_sph}
              onChange={handleHbrxChange}
            />
            <input 
              type="text" 
              name="hb_od_cyl"
              value={hbrx.hb_od_cyl}
              onChange={handleHbrxChange}
            />
            <input 
              type="text" 
              name="hb_od_axis"
              value={hbrx.hb_od_axis}
              onChange={handleHbrxChange}
            />
            <input 
              type="text" 
              name="hb_od_vision"
              value={hbrx.hb_od_vision}
              onChange={handleHbrxChange}
            />
          </div>
          <div className="refraction-row">
            <div>OS</div>
            <input 
              type="text" 
              name="rx_os_sph"
              value={hbrx.rx_os_sph}
              onChange={handleHbrxChange}
            />
            <input 
              type="text" 
              name="rx_os_cyl"
              value={hbrx.rx_os_cyl}
              onChange={handleHbrxChange}
            />
            <input 
              type="text" 
              name="rx_os_axis"
              value={hbrx.rx_os_axis}
              onChange={handleHbrxChange}
            />
            <input 
              type="text" 
              name="rx_os_vision"
              value={hbrx.rx_os_vision}
              onChange={handleHbrxChange}
            />
          </div>
        </div>
      </div>








      {/* Refraction */}
      <div className="form-section">
        <h2>Refraction</h2>
        <div className="refraction-grid">
          <div className="refraction-header">
            <div></div>
            <div>Sph</div>
            <div>Cyl</div>
            <div>Axis</div>
            <div>Vision</div>
          </div>
          <div className="refraction-row">
            <div>OD</div>
            <input 
              type="text" 
              name="od_sph"
              value={refraction.od_sph}
              onChange={handleRefractionChange}
            />
            <input 
              type="text" 
              name="od_cyl"
              value={refraction.od_cyl}
              onChange={handleRefractionChange}
            />
            <input 
              type="text" 
              name="od_axis"
              value={refraction.od_axis}
              onChange={handleRefractionChange}
            />
            <input 
              type="text" 
              name="od_vision"
              value={refraction.od_vision}
              onChange={handleRefractionChange}
            />
          </div>
          <div className="refraction-row">
            <div>OS</div>
            <input 
              type="text" 
              name="os_sph"
              value={refraction.os_sph}
              onChange={handleRefractionChange}
            />
            <input 
              type="text" 
              name="os_cyl"
              value={refraction.os_cyl}
              onChange={handleRefractionChange}
            />
            <input 
              type="text" 
              name="os_axis"
              value={refraction.os_axis}
              onChange={handleRefractionChange}
            />
            <input 
              type="text" 
              name="os_vision"
              value={refraction.os_vision}
              onChange={handleRefractionChange}
            />
          </div>
        </div>
      </div>





      {/* Follow Up */}
      <div className="form-section">
        <h2>Follow Up</h2>
        <div className="form-row">
          <div className="form-group">
            <label>
              <input 
                type="checkbox" 
                checked={needsFollowUp}
                onChange={(e) => setNeedsFollowUp(e.target.checked)}
              />
              Needs Follow Up
            </label>
          </div>
          <div className="form-group">
            <label>Follow Up Date</label>
            <input 
              type="date" 
              value={followUpDate}
              onChange={(e) => setFollowUpDate(e.target.value)}
              disabled={!needsFollowUp}
            />
          </div>
        </div>
        <div className="form-group">
          <label>Remarks</label>
          <textarea 
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            rows={4}
          />
        </div>
      </div>

      <div className="form-actions">
        <button type="submit" className="submit-btn">Generate Eye Exam Report</button>
      </div>
    </form>
  </div>
)}





{selectedOption === "viewEyeExam" && (
    

  
  <div className="eye-exam-container">
    <div className="header-section">
      <h1 className="section-title">Eye Examination Records</h1>
      <div className="controls">
        <input 
          type="text" 
          placeholder="Search records..." 
          className="search-input"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <select 
          className="filter-select"
          onChange={(e) => setFilterOption(e.target.value)}
          value={filterOption}
        >
          <option value="all">All Records</option>
          <option value="today">Today</option>
          <option value="week">This Week</option>
          <option value="month">This Month</option>
        </select>

      {/* <button className="ecp-btn-eye-exam">Export as file</button> */}
        
      </div>
    </div>

    {filteredRecords.length === 0 ? (
      <div className="no-records">
        <img src="/empty-state.svg" alt="No records" className="empty-icon" />
        <p>No examination records found</p>
      </div>
    ) : (
      <div className="table-responsive">
        <table className="eye-exam-table">
          <thead>
            <tr>
              <th>Patient Name</th>
              <th>Patient ID</th>
              <th>Date</th>
              <th>Age</th>
              <th>Chief Complaint</th>
              <th>VA (OD/OS)</th>
              <th>Refrac (od_cyl & od_axis)</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredRecords.map((record) => (
              <tr key={record.id} className="exam-row">
                <td>{record.patientInfo?.name}</td>
                <td>{record.patientInfo?.id || 'N/A'}</td>
                <td>{new Date(record.patientInfo?.date).toLocaleDateString()}</td>
                <td>{record.patientInfo?.age || 'N/A'}</td>
                <td className="complaint-cell">
                  {record.history?.chiefComplaint?.substring(0, 30)}...
                </td>
                <td>
                  {record.visualAcuity?.od_cg || 'N/A'} / {record.visualAcuity?.os_cg || 'N/A'}
                </td>
                <td>
                  {record.refraction?.od_sph || 'N/A'} {record.refraction?.od_cyl || ''} x {record.refraction?.od_axis || ''}
                </td>
                <td>
                  <div className="action-buttons">
                    <button 
                      className="pdf-btn"
                      onClick={() => generateEyeExamPDF(record)}
                    >
                      <Download size={16} /> PDF
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
    {/* Record Detail Modal */}
    {selectedRecord && (
      <div className="modal-overlay">
        <div className="record-modal">
          <div className="modal-header">
            <h3>Exam Details</h3>
            <button onClick={() => setSelectedRecord(null)}>×</button>
          </div>
          <div className="modal-content">
            <div className="patient-details">
              <h4>{selectedRecord.patientInfo?.name}</h4>
              <p>ID: {selectedRecord.patientInfo?.id}</p>
              <p>Age: {selectedRecord.patientInfo?.age} | Gender: {selectedRecord.patientInfo?.gender}</p>
            </div>
            
            <div className="section">
              <h5>History</h5>
              <p><strong>Chief Complaint:</strong> {selectedRecord.history?.chiefComplaint}</p>
              <p><strong>HPC:</strong> {selectedRecord.history?.hpc}</p>
            </div>

            <div className="section">
              <h5>Examination</h5>
              <div className="two-column">
                <div>
                  <p><strong>VA OD:</strong> {selectedRecord.visualAcuity?.od_cg}</p>
                  <p><strong>VA OS:</strong> {selectedRecord.visualAcuity?.os_cg}</p>
                </div>
                <div>
                  <p><strong>Refraction OD:</strong> {selectedRecord.refraction?.od_sph} {selectedRecord.refraction?.od_cyl} x {selectedRecord.refraction?.od_axis}</p>
                  <p><strong>Refraction OS:</strong> {selectedRecord.refraction?.os_sph} {selectedRecord.refraction?.os_cyl} x {selectedRecord.refraction?.os_axis}</p>
                </div>
              </div>
            </div>

            <button 
              className="generate-full-btn"
              onClick={() => generateEyeExamPDF(selectedRecord)}
            >
              Generate Full Report
            </button>
          </div>
        </div>
      </div>
    )}
  </div>
)}










{selectedOption === "patienteyeExam" && (
  
  <div className="eye-exam-container">
  <div className="header-section">
    <h1 className="section-title">Eye Examination Report for Patient</h1>
    <div className="controls">
      <input 
        type="text" 
        placeholder="Search records..." 
        className="search-input"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <select 
        className="filter-select"
        onChange={(e) => setFilterOption(e.target.value)}
        value={filterOption}
      >
        <option value="all">All Records</option>
        <option value="today">Today</option>
        <option value="week">This Week</option>
        <option value="month">This Month</option>
      </select>

    {/* <button className="ecp-btn-eye-exam">Export as file</button> */}
      
    </div>
  </div>

  {filteredRecords.length === 0 ? (
    <div className="no-records">
      <img src="/empty-state.svg" alt="No records" className="empty-icon" />
      <p>No examination records found</p>
    </div>
  ) : (
    <div className="table-responsive">
      <table className="eye-exam-table">
        <thead>
          <tr>
            <th>Patient Name</th>
            <th>Patient ID</th>
            <th>Date</th>
            <th>Age</th>
            <th>Chief Complaint</th>
            <th>VA (OD/OS)</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredRecords.map((record) => (
            <tr key={record.id} className="exam-row">
              <td>{record.patientInfo?.name}</td>
              <td>{record.patientInfo?.id || 'N/A'}</td>
              <td>{new Date(record.patientInfo?.date).toLocaleDateString()}</td>
              <td>{record.patientInfo?.age || 'N/A'}</td>
              <td className="complaint-cell">
                {record.history?.chiefComplaint?.substring(0, 30)}...
              </td>
              <td>
                {record.visualAcuity?.od_cg || 'N/A'} / {record.visualAcuity?.os_cg || 'N/A'}
              </td>
             
              <td>
                <div className="action-buttons">
                  <button 
                    className="pdf-btn"
                    onClick={() => generatePatientEyeExam(record)}
                  >
                    <Download size={16} /> PDF
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )}

</div>
)}



{/* Notification Panel */} 
{selectedOption === "notification" && (
  <div className="notification-section">
    <div className="notification-header">
      <h3>Patient Follow-ups</h3>
      <p className="notification-subtitle">
        {todayCount > 0 
          ? `${todayCount} follow-up${todayCount > 1 ? 's' : ''} today`
          : 'No follow-ups today'}
      </p>
    </div>

    <div className="notification-divider"></div>

    {error && (
      <div className="notification-error">
        <p>Error: {error}</p>
      </div>
    )}

    {loading ? (
      <div className="loading-notifications">
        <p>Loading notifications...</p>
      </div>
    ) : notifications.length === 0 ? (
      <div className="empty-notifications">
        <p>⚠️ No upcoming follow-ups found</p>
      </div>
    ) : (
      <div className="notification-list">
        {notifications.map((item) => (
          <div
            key={item.id}
            className={`notification-item ${item.isToday ? 'today-item' : ''}`}
            style={{
              borderLeft: `4px solid ${getPriorityColor(item.followUpDate)}`
            }}
          >
            <div
              className="notification-avatar"
              style={{ backgroundColor: getPriorityColor(item.followUpDate) }}
            >
              {item.followUpDate.getDate()}
            </div>

            <div className="notification-content">
              <p className={`notification-title ${item.isToday ? 'today-title' : ''}`}>
                {item.patientName}
              </p>

              <p className="notification-date">Follow-up: {item.formattedDate}</p>

              {item.telephoneNo && (
                <p className="notification-notes">
                  📞 Tel: {item.telephoneNo}
                </p>
              )}

              {item.followUpDescription && (
                <p className="notification-notes">
                  📝 {item.followUpDescription}
                </p>
              )}

              {item.notes && (
                <p className="notification-notes">{item.notes}</p>
              )}
            </div>

            <div className="notification-extra">
              <p className="notification-days">
                {item.isToday 
                  ? 'TODAY' 
                  : `${item.daysDifference} days`}
              </p>
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
)}




             
           

      </div>
    </div>
  );
};

export default Body;
